var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2b5748;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 66,
    height: 66,
    rx: 18.99,
    ry: 18.99
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "45.45 43.61 43.86 42.02 42.87 43 45.45 45.58 50.11 40.92 49.13 39.93 45.45 43.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.19,35.15v-13.24c0-1.15-.94-2.08-2.08-2.08h-2.08v-.69c0-1.15-.94-2.08-2.08-2.08h-2.78c-1.15,0-2.08.94-2.08,2.08v.69h-5.56v-.69c0-1.15-.94-2.08-2.08-2.08h-2.78c-1.15,0-2.08.94-2.08,2.08v.69h-3.47c-1.15,0-2.08.94-2.08,2.08v22.23c0,1.15.94,2.08,2.08,2.08h19.6c1.27,2.47,3.84,4.17,6.8,4.17,4.21,0,7.64-3.43,7.64-7.64,0-3.98-3.06-7.26-6.95-7.61ZM37.46,19.13c0-.38.31-.69.69-.69h2.78c.38,0,.69.31.69.69v2.78c0,.38-.31.69-.69.69h-2.78c-.38,0-.69-.31-.69-.69v-2.78ZM24.95,19.13c0-.38.31-.69.69-.69h2.78c.38,0,.69.31.69.69v2.78c0,.38-.31.69-.69.69h-2.78c-.38,0-.69-.31-.69-.69v-2.78ZM19.39,21.91c0-.38.31-.69.69-.69h3.47v.69c0,1.15.94,2.08,2.08,2.08h2.78c1.15,0,2.08-.94,2.08-2.08v-.69h5.56v.69c0,1.15.94,2.08,2.08,2.08h2.78c1.15,0,2.08-.94,2.08-2.08v-.69h2.08c.38,0,.69.31.69.69v3.47h-26.4v-3.47ZM20.09,44.84c-.38,0-.69-.31-.69-.69v-17.37h26.4v8.37c-.99.09-1.93.37-2.78.81v-6.4h-20.84v12.51h16.71c-.02.23-.04.46-.04.69,0,.72.11,1.42.3,2.08h-19.06ZM39.15,40.67h-2.38v-4.17h4.86v.36c-1.18.97-2.05,2.3-2.48,3.81ZM41.63,35.11h-4.86v-4.17h4.86v4.17ZM29.82,35.11v-4.17h5.56v4.17h-5.56ZM35.38,36.5v4.17h-5.56v-4.17h5.56ZM23.56,35.11v-4.17h4.86v4.17h-4.86ZM28.43,36.5v4.17h-4.86v-4.17h4.86ZM46.49,49.01c-3.45,0-6.25-2.81-6.25-6.25s2.81-6.25,6.25-6.25,6.25,2.81,6.25,6.25-2.81,6.25-6.25,6.25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ddcfda79859fd7dfdb5b1a6beb9dbf8a.svg";
export { ForwardRef as ReactComponent };